export const containerCommonStyles = {
  backgroundColor: "white",
  padding: "26px",
  borderRadius: "15px",
  marginBottom: "1rem",
  "& p": {
    fontSize: "14px",
  },
};

export const headingStyles = {
  backgroundColor: "#32B194",
  "& p": {
    color: "white",
    fontWeight: "500",
  },
};

export const tableRowStyles = {
  padding: "10px 5px",
  whiteSpace: "nowrap",
};
